import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/* eslint-disable @typescript-eslint/ban-ts-comment */
import { transformToNestObject } from 'react-hook-form';
/**
 * From 0.32.0, Yup add TypeScript support and `path` typing is optional that's why we have `@ts-expect-error`
 * FYI: `path`: a string, indicating where there error was thrown. `path` is empty at the root level.
 * react-hook-form's values are object so path is defined
 * https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
 */

var parseErrorSchema = function parseErrorSchema(error, validateAllFieldCriteria) {
  return Array.isArray(error.inner) && error.inner.length ? error.inner.reduce(function (previous, _ref) {
    var path = _ref.path,
        message = _ref.message,
        type = _ref.type;
    // @ts-expect-error
    var previousTypes = previous[path] && previous[path].types || {};
    var key = path || type;
    return Object.assign(Object.assign({}, previous), key ? _defineProperty({}, key, Object.assign(Object.assign({}, previous[key] || {
      message: message,
      type: type
    }), validateAllFieldCriteria ? {
      types: Object.assign(Object.assign({}, previousTypes), _defineProperty({}, type, previousTypes[type] ? // @ts-expect-error
      [].concat(_toConsumableArray([].concat(previousTypes[type])), [message]) : message))
    } : {})) : {});
  }, {}) : _defineProperty({}, error.path, {
    message: error.message,
    type: error.type
  });
};

export var yupResolver = function yupResolver(schema) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    abortEarly: false
  };
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, context) {
      var validateAllFieldCriteria,
          parsedErrors,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validateAllFieldCriteria = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              _context.prev = 1;

              if (options.context && process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead");
              }

              _context.next = 5;
              return schema.validate(values, Object.assign(Object.assign({}, options), {
                context: context
              }));

            case 5:
              _context.t0 = _context.sent;
              _context.t1 = {};
              return _context.abrupt("return", {
                values: _context.t0,
                errors: _context.t1
              });

            case 10:
              _context.prev = 10;
              _context.t2 = _context["catch"](1);
              parsedErrors = parseErrorSchema(_context.t2, validateAllFieldCriteria);
              return _context.abrupt("return", {
                values: {},
                errors: transformToNestObject(parsedErrors)
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};